import React from "react"
import "./courses.scss"
import { Link as GatsbyLink } from "gatsby"
import CarouselSlider from "../../slider/Slider"
import { useMediaQuery } from "react-responsive"
import ItemCard from "../../common/ItemCard/ItemCard"

/**
 * Option B — Keep useMediaQuery, but avoid SSR/hydration mismatch.
 * We render a non-slider list on the very first paint, then (after mount)
 * we switch to the slider on tablet/mobile. This prevents sliders from
 * initializing against empty/incorrect markup.
 */
const PopularCourses = ({ featured = [] }) => {
  // Track mount so initial client render matches server output
  const [mounted, setMounted] = React.useState(false)
  React.useEffect(() => setMounted(true), [])

  // Media queries (safe to call on server — they’ll be false there)
  const isTablet = useMediaQuery({ query: "(max-width: 768px)" })
  const isMobile = useMediaQuery({ query: "(max-width: 480px)" })

  // Only show the slider after mount; before that, show the non-slider list
  const showSlider = mounted && isTablet

  return (
    <div className="mostpopular_detailes">
      <div className="container">
        <div className="populartitles_detailes">
          <div className="row_main">
            <div className="mostpopularleft_titledata">
              <h2 className="courses_title">Check out our most Popular Courses</h2>
              <p className="courses_description">All Courses are ISO-Compliant BIM Courses</p>
            </div>
            <div className="allcourses_btn">
              <GatsbyLink to="/courses" className="seecorses">
                See All courses
              </GatsbyLink>
            </div>
          </div>
        </div>

        <div className="corces_data">
          <div className="row_main">
            {!featured.length ? null : showSlider ? (
              <CarouselSlider
                slidesToShow={isMobile ? 1 : 2}
                slidesToScroll={isMobile ? 1 : 2}
                showSlideDots={false}
              >
                {featured.map((item, i) => (
                  // Wrap each slide in a div; many sliders require a single child element
                  <div key={i}>
                    <ItemCard
                      slug={item.slug}
                      coverPhoto={item.coverPhoto}
                      title={item.title}
                      category={item.category}
                      courseReference={item.courseReference}
                      netFee={item.product?.netFee}
                      duration={item.duration}
                      trainingMode={item.trainingMode}
                      courseRuns={item.courseRuns}
                    />
                  </div>
                ))}
              </CarouselSlider>
            ) : (
              // Server render (and initial client paint) — non-slider list to avoid hydration issues
              <>
                {featured.map((item, i) => (
                  <ItemCard
                    key={i}
                    slug={item.slug}
                    coverPhoto={item.coverPhoto}
                    title={item.title}
                    category={item.category}
                    courseReference={item.courseReference}
                    netFee={item.product?.netFee}
                    duration={item.duration}
                    trainingMode={item.trainingMode}
                    courseRuns={item.courseRuns}
                  />
                ))}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default PopularCourses
